import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsReceipt } from "react-icons/bs";

import { appStore } from "../../stores/appStore";
import Bonus from "../Bonus/Bonus";
import { StyledFooterBonus, StyledFooterOdds, StyledbetSlipBtn, StyledbetSlipBtnCount } from "./FooterStyle";

const Footer = () => {
  const [btnDisabled, setBtnDisabled] = useState(true);
  const { t } = useTranslation("General");

  // getting and setting data from appStore
  const {
    setShowBetSlip,
    betSlipSelections,
    calculatedBetSlip,
    betSlipDetails,
    currencyCode,
    sessionCurrencyCode,
    playerBalance,
  } = appStore((state) => ({
    setShowBetSlip: state.setShowBetSlip,
    betSlipSelections: state.betSlipSelections,
    calculatedBetSlip: state.calculatedBetSlip,
    betSlipDetails: state.betSlipDetails,
    playerBalance: state.playerBalance,
    currencyCode: state.currencyCode,
    sessionCurrencyCode: state.sessionCurrencyCode
  }));

  // if betslipSelection is 0 then betslip button disable
  useEffect(() => {
    setBtnDisabled(betSlipSelections.length === 0 ? true : false);
  }, [betSlipSelections]);

  // show betslip component
  const betSlipBtn = () => {
    window.scrollTo(0, 0);
    window.parent.postMessage({ action: "scrolltotop" }, "*");
    setShowBetSlip(true);
  };

  return (
    <React.Fragment>
      <footer className="footer position-fixed bottom-0 start-0 end-0 m-auto">
        <div
          className="position-absolute betslipBtn-position"
        >
          <StyledbetSlipBtn selected={!btnDisabled}
            onClick={betSlipBtn}
            disabled={btnDisabled}
            className={`position-relative border border-secondary rounded-3 betslipBtn w-100 rounded-pill
              ${btnDisabled
                ? "text-secondary bg-white"
                : "text-white bg-secondary"}
           ` }
          >
            <StyledbetSlipBtnCount selected={betSlipSelections.length !== 0}
              className="position-absolute betslip-badge p-1 translate-middle badge rounded-pill bg-white text-secondary border border-secondary">
              {betSlipSelections.length}
            </StyledbetSlipBtnCount>
            <BsReceipt size="17px" />
            {" "}
            &nbsp;{t("V-betslip")}
          </StyledbetSlipBtn>

        </div>
        <div className="bg-secondary">
          <StyledFooterOdds className="bg-primary text-white d-flex justify-content-between p-2 m-0">
            <b>{t("Total Odds")}: {betSlipSelections.length == 0 ? "0.00" : calculatedBetSlip.totalOdds || "0.00"}</b>
            <b>
              {t("Balance")}: {sessionCurrencyCode ? sessionCurrencyCode : currencyCode} {playerBalance?.toLocaleString(undefined, { minimumFractionDigits: 2 }) || "0.00"}
            </b>
            {/* <b>
              {t("To Win")}: {currencyCode}{" "}
              {calculatedBetSlip.finalReturnAmount || "0.00"}
            </b> */}
          </StyledFooterOdds>
          {betSlipDetails.betType === "SUPER_ODDS" ?
            betSlipSelections.length === 0 &&
            <StyledFooterBonus className="text-center p-1 text-white m-0 bonus-font-size">
              <Bonus />
            </StyledFooterBonus>
            :
            <StyledFooterBonus className="text-center p-1 text-white m-0 bonus-font-size">
              <Bonus />
            </StyledFooterBonus>

          }
        </div>

      </footer>
    </React.Fragment>
  );
};
export default Footer;
